



























































import Loader from '@/contexts/frontend/Loader.vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faPencilAlt,
  faTrashAlt,
  faSearch,
  faTimes
} from '@fortawesome/free-solid-svg-icons'

library.add(faPencilAlt, faTrashAlt, faSearch, faTimes)

export default {
  components: {
    loader: Loader
  },
  props: {
    clientId: String
  },
  data: function() {
    return {
      loading: false,
      users: [],
      userContains: ''
    }
  },
  mounted() {
    this.loading = true
    this.$api.clientAdmin
      .ListUsers()
      .then(results => (this.users = results))
      .finally(() => (this.loading = false))
  },
  methods: {
    findUsers() {
      if (this.userContains.length > 1) {
        this.$api.clientAdmin
          .FindUsers(this.userContains)
          .then(results => (this.users = results))
      } else if (this.userContains.length == 0) {
        this.loading = true
        this.$api.clientAdmin
          .ListUsers()
          .then(results => (this.users = results))
          .finally(() => (this.loading = false))
      }
    },
    clearSearch() {
      this.userContains = ''
      this.findUsers()
    }
  },
  computed: {
    usersFound() {
      return this.users.length > 0
    },
    hasSearchCriteria() {
      return this.userContains.length > 0
    }
  }
}
